import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { faCircleArrowDown, faTrash } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import Backdrop from "../../../Backdrop";
import InfoIcon from "../../../InfoIcon";
import useFetch from "../../../../hook/useFetch";
import { notificationActions } from "../../../../store/notification-slice";
import Filter from "./mobile/filter";

export default function MobileComponent() {
    const [mobileItems, setMobileItems] = useState();
    const files = useSelector(state => state.file.files);
    const filteredFiles = useSelector(state => state.file.filteredfiles);

    useEffect(() => {
        const visibleFiles = filteredFiles ?? files;
        setMobileItems((visibleFiles || []).map(file => <MobileItem key={file.id} file={file} />));
    }, [filteredFiles, files]);

    if (!mobileItems) return <Skeleton count={20} />;

    return <Fragment>
        <Filter>{mobileItems.length > 0 ? mobileItems : <p className="text-muted mb-0">No files found.</p>}</Filter>
        <Backdrop />
    </Fragment>;
}

function MobileItem({ file }) {
    const [showContent, setShowContent] = useState(false);
    const { del } = useFetch();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const deleteFile = event => {
        event.stopPropagation();
        del("/admin/file", { identifier: file.identifier }, data => {
            dispatch(notificationActions.setNotification({ message: data, status: false }));
        }, () => {
            dispatch(notificationActions.setNotification({ message: "file deleted", status: true }));
            navigate("/admin/files", { state: { refetch: true } });
        });
    };

    return <Fragment>
        <button type="button" className="mobile-overflow-card card shadow bg-white rounded p-3 mb-2 w-100 text-start border-0" aria-expanded={showContent} onClick={() => setShowContent(current => !current)}>
            <span className="responsive-card-summary">
                <span>{file.name}</span>
                <span className="text-muted small">{file.type}</span>
            </span>
            <InfoIcon icon={faCircleArrowDown} size="xl" />
        </button>
        {showContent && <div className="table-responsive mb-3">
            <table className="table table-striped table-bordered mb-0"><tbody>
                <tr><th>ID</th><td>{file.id}</td></tr>
                <tr><th>Name</th><td className="text-break">{file.name}</td></tr>
                <tr><th>Preview</th><td><a href={file.path} target="_blank" rel="noreferrer"><img src={file.path} alt={file.name || "File preview"} width="80" height="80" style={{ objectFit: "contain" }} /></a></td></tr>
                <tr><th>StorePath</th><td className="text-break">{file.storepath}</td></tr>
                <tr><th>Path</th><td className="text-break"><a href={file.path} target="_blank" rel="noreferrer">{file.path}</a></td></tr>
                <tr><th>Identifier</th><td className="text-break">{file.identifier}</td></tr>
                <tr><th>Type</th><td>{file.type}</td></tr>
                <tr><th>CreatedOn</th><td>{file.created_on}</td></tr>
                <tr><th>Delete</th><td><button type="button" className="btn btn-warning" onClick={deleteFile}><InfoIcon icon={faTrash} title="delete file" /></button></td></tr>
            </tbody></table>
        </div>}
    </Fragment>;
}
